'use client';

import React, { useState, useEffect } from 'react';
// import Image from 'next/image'; // 現状未使用のためコメントアウト (imgタグをImageコンポーネントに置き換える際に再度有効化)

interface ProductInfo {
  imageUrl: string;
  text: string;
  linkUrl: string;
  price?: string; // 価格情報を追加 (任意)
}

// おすすめPC製品のデータ例
const products: ProductInfo[] = [
  {
    imageUrl: 'https://m.media-amazon.com/images/I/71aK1M3NxxL._AC_SX679_.jpg',
    text: 'Apple 2025 MacBook Air M4 チップ搭載 13 インチノートブック: Apple Intelligence のために設計、13.6 インチ Liquid Retina ディスプレイ、16GBユニファイドメモリ、 256GB SSD ストレージ、12MP センターフレームカメラ、Touch ID - スカイブルー',
    linkUrl: 'https://amzn.to/3ZpF4XI',
  },
  {
    imageUrl: 'https://m.media-amazon.com/images/I/612MlWlXxJL._AC_SY450_.jpg',
    text: '【Amazon.co.jp限定】HP ノートパソコン 15-fd インテル第13世代 インテル Core i5-1334U 16GBメモリ 512GB SSD Bluetooth 指紋認証 薄型 ナチュラルシルバー 1年間メーカー保証 HP 240 Bluetoothマウス同梱 最新Microsoft Office Home & Business 2024',
    linkUrl: 'https://amzn.to/3YWVOFz',
  },
  {
    imageUrl: 'https://m.media-amazon.com/images/I/71NGGgMlvfL._AC_SY450_.jpg',
    text: 'Dell ノートパソコン Inspiron 15 3520 15.6インチ Intel Core i5-1235U メモリ16GB SSD512GB Office 2021搭載 Windows 11 カーボンブラック 翌営業日対応オンサイト出張修理サービス1年 NI355A-EHHBB',
    linkUrl: 'https://amzn.to/3SRzmKp',
  },
  {
    imageUrl: 'https://m.media-amazon.com/images/I/61YW3YayYFL._AC_SY450_.jpg',
    text: 'ASUS ノートパソコン Vivobook 14 X1405VA 14インチ インテル Core i7 13620H メモリ16GB SSD 512GB WPS Office搭載 Windows 11 バッテリー駆動 9.2時間 重量1.6kg Wi-Fi 6E インディーブラック PC Game Pass 3ヶ月利用権付き インディーブラック X1405VA-I7H165W',
    linkUrl: 'https://amzn.to/4mrWxJ2',
  },
  {
    imageUrl: 'https://m.media-amazon.com/images/I/51ac7qN0SGL._AC_SY450_.jpg',
    text: '【薄型大画面・軽量1.7kg】【Core i7 & Office搭載】MSIビジネスノートPC Modern15 メモリ32GB/SSD512GB/15.6インチ FHD/Corei7-1355U/Windows 11 Home/Microsoft 365 Basic + Office Home & Business 2024/Modern-15-F13MG-5013JP',
    linkUrl: 'https://amzn.to/3SeGuR6',
  },
];

const SLIDE_INTERVAL = 5500; // スライド切り替え間隔 (ミリ秒)

const TopArea: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (products.length === 0) return;

    const timer = setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % products.length);
    }, SLIDE_INTERVAL);

    return () => clearTimeout(timer);
  }, [currentIndex]);

  const currentProduct = products.length > 0 ? products[currentIndex] : null;

  if (!currentProduct) {
    return null; // 表示する製品がない場合は何もレンダリングしない
  }

  return (
    <div className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white p-4 sm:p-6 shadow-md">
      <div className="container mx-auto text-center">
        <h3 className="text-lg sm:text-xl font-semibold mb-4">おすすめPC</h3>
        <a
          href={currentProduct.linkUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full max-w-md mx-auto bg-white rounded-lg shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl hover:scale-105 group"
        >
          <div className="relative h-56 sm:h-64 w-full overflow-hidden">
            {/* Next.jsのImageコンポーネントを使用する場合は、widthとheight、またはfillを指定する必要があります */}
            {/* ここでは仮の画像なので通常のimgタグを使用していますが、Next/Imageに置き換えることを推奨します */}
            <img
              src={currentProduct.imageUrl}
              alt={currentProduct.text}
              className="absolute inset-0 w-full h-full object-contain p-3 transition-transform duration-300 group-hover:scale-105"
              // Next.js Image component example (ensure images are in public folder and width/height are correct)
              // layout="fill" // or width={...} height={...}
            />
          </div>
          <div className="p-3 sm:p-4 bg-gray-50">
            <h4
              className="text-sm sm:text-base font-medium text-gray-800 truncate h-10 flex items-center justify-center"
              title={currentProduct.text}
            >
              {currentProduct.text}
            </h4>
            {currentProduct.price && (
              <p className="text-xs sm:text-sm text-green-600 font-semibold mt-1">
                {currentProduct.price}
              </p>
            )}
          </div>
        </a>
      </div>
    </div>
  );
};

export default TopArea;
